//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BalCavityNumber",1,0],[0,"CirCavityNumber",1,0],[0,"CirRadius",1,0],[0,"CirRotateAngle",1,0],[0,"CirStartAngle",1,0],[1,"DimBalFirst",0,"Expression",0],[1,"DimBalSecond",0,"Expression",0],[1,"DimXdist",0,"Expression",0],[1,"DimYdist",0,"Expression",0],[0,"LayoutVector",1,"Direction",0],[0,"LinXnumber",1,0],[0,"LinYnumber",1,0],[0,"MwLayoutType",1,0],[0,"RotatePoint",1,"Point",0],[1,"SelectCavity",0,"SelectNXObjectList",0],[0,"SubType",1,0],[0,"Xref",1,0],[0,"Yref",1,0]],[[[],"Layout",{},0,0],[[],"Insertpocket",{},0,0],[[],"Transform",{},0,0],[[],"Remove",{},0,0],[[],"Autocenter",{},0,0],[[],"CreateLayout",{},0,0],[[],"PutLayoutInfo",{},0,0],[[],"RemoveCavitiesFromLayout",{},0,0],[["aCavity"],"AddACavity",{},1,0],[["aCavity"],"RemoveACavity",{},1,0],[[],"ClearSelectedCavities",{},0,0],[[],"GetCavityNumberAlongX",{R_:{cavityNumber:''}},0,0],[["cavityNumber"],"SetCavityNumberAlongX",{},1,0],[[],"GetCavityNumberAlongY",{R_:{cavityNumber:''}},0,0],[["cavityNumber"],"SetCavityNumberAlongY",{},1,0],[["bModified"],"SetMoldCostAssemblyModified",{},1,0]],[]];
SPLM.Tooling.LayoutBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.LayoutBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.LayoutBuilder.LayoutType = Object.freeze({
    "Rectangle" : "Rectangle", "Circular" : "Circular", "Smart" : "Smart"});

SPLM.Tooling.LayoutBuilder.LayoutSubType = Object.freeze({
    "Balance" : "Balance", "Linear" : "Linear", "Radial" : "Radial", "Constant" : "Constant"});

SPLM.Tooling.LayoutBuilder.BalNumber = Object.freeze({
    "Two" : "Two", "Four" : "Four"});

SPLM.Tooling.LayoutBuilder.XrefNum = Object.freeze({
    "Block" : "Block", "Move" : "Move"});

SPLM.Tooling.LayoutBuilder.YrefNum = Object.freeze({
    "Block" : "Block", "Move" : "Move"});

export default SPLM;